module.exports = __webpack_public_path__ + "e85b961cc2ad7b72c62d452565f535e1.pdf";